import V1ApiService from "./V1ApiService"
import ApiService from "./ApiService";

export default function createApiService(apiVersion: string, token?: string): ApiService| undefined {
  if (apiVersion === "V1") {
    return new V1ApiService(token);
  }else{
    return undefined;
  }
}